export default __webpack_public_path__ + "static/ai-consultancy-2-66c67f8c3508defad1556f41c0189c25.webp";